import EditEntepriseValueModal from './EditEntepriseValueModal.component';

export default EditEntepriseValueModal;
